module.exports = __webpack_public_path__ + "img/ico-grade-gold.5ae96786.svg";